import React, { useRef, useState, useEffect } from 'react';
import 'highlight.js/styles/github.css'; // Import a syntax highlighting style
import hljs from 'highlight.js/lib/core';
import sql from 'highlight.js/lib/languages/sql';
import axios from 'axios';
import { getToken } from '../../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { queryResultsTable } from '../../utils/ktcUtils';
import '../../css/sql.css';
import SqlEditor from '../../components/SqlEditor';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/theme-github'; // You can choose any theme you prefer
import { groupBy } from '../../utlis';

// Register SQL language for syntax highlighting
hljs.registerLanguage('sql', sql);

const SQLQueryPage = () => {
  const [query, setQuery] = useState(''); // Query input state
  const [result, setResult] = useState(null); // Query result state
  const [rowsAffected, setRowsAffected] = useState(null); // Rows affected for non-select queries
  const [error, setError] = useState(null); // Error state
  const [loading, setLoading] = useState(null); // Error state
  const [counter, setCounter] = useState(1); // Start counter from 1
  const [objects, setObjects] = useState([]);

  const [isNestedArray, setIsNestedArray] = useState(false);
  const token = getToken();
  const intervalRef = useRef(null); // Store interval ID
  useEffect(() => {
    // Fetch MySQL tables from backend
    axios
      .get(`${API_URL}/${ENDPOINTS.SYS}/get-db-objects`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setObjects(res.data);
      });
  }, []);

  const handleChange = (newSql) => {
    setQuery(newSql);
  };

  // Function to execute query
  const executeQuery = async () => {
    try {
      setLoading(true);

      setCounter(1); // Reset counter

      // Start a new interval
      intervalRef.current = setInterval(() => {
        setCounter((prev) => prev + 1); // Increment counter each second
        console.log('Interval running', counter); // Debugging: check if counter updates
      }, 1000);

      setError(null);
      setResult(null);
      setRowsAffected(null);

      // Mock API call to execute query (replace with your API endpoint)
      const response = await axios.post(
        `${API_URL}/${ENDPOINTS.SYS}/execute-query`,
        { query },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      const { data } = response;
      // Clear the previous interval if it exists
      if (intervalRef.current) {
        console.log('Clearing old interval'); // Debugging
        clearInterval(intervalRef.current);
      }
      //  console.log('data:', data);

      // Check if the response includes rows or just metadata
      if (Array.isArray(data) && data.length > 0) {
        const isNestedArray = data.some((data) => Array.isArray(data));
        setIsNestedArray(isNestedArray);
        setResult(data); // Handle SELECT query results
      } else if (data.affectedRows !== undefined) {
        setRowsAffected(data.affectedRows); // Handle INSERT, UPDATE, DELETE
      } else {
        setResult([]); // No data returned (e.g., empty SELECT result)
      }
      if (data.error) {
        setError(data.error);
      }
      setLoading(false);
    } catch (err) {
      // Handle errors
      setLoading(false);
      setError(
        err.response?.data?.message || `Failed to execute query. ${err.message}`
      );
    }
  };

  const handleBrowseClick = (e, tableName) => {
    e.preventDefault();
    // Set the query for "Browse" and execute it
    setQuery(`SELECT * FROM ${tableName} limit 100`);
    // executeQuery();
  };

  const handleStructureClick = (e, name, type) => {
    e.preventDefault();

    // Set the query for "Structure" and execute it
    if (type === 'Table') {
      setQuery(`DESC ${name}`);
    } else {
      setQuery(`SHOW CREATE ${type} ${name}`);
    }
    // executeQuery();
  };

  //   console.log('result:', result);
  //   console.log('affected:', rowsAffected);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  let filteredObjects = objects.filter((table) =>
    Object.values(table)[0].toLowerCase().includes(searchQuery.toLowerCase())
  );

  filteredObjects = groupBy(filteredObjects, 'type');

  console.log(filteredObjects);

  const listStyle = {
    listStyleType: 'none', // Remove default list item style (bullets, numbers)
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
  };

  return (
    <div className="mt-5" style={{ width: '95%', margin: 'auto' }}>
      <div className="row">
        <div className="col-2">
          <h2>Database Objects</h2>
          {/* Search Input */}
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search for a table"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <div className="accordion" id="dbObjectsAccordion">
            {Object.entries(filteredObjects).map(([type, items], index) => (
              <div className="accordion-item" key={type}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    aria-expanded="true"
                    aria-controls={`collapse-${index}`}
                  >
                    {type}
                  </button>
                </h2>
                <div
                  id={`collapse-${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#dbObjectsAccordion"
                >
                  <div className="accordion-body">
                    <ul className="list-group">
                      {items.map((item, i) => (
                        <li key={item.name} className="list-group-item">
                          <strong>{item.name}</strong>
                          <div
                          // style={{
                          //   border: '1px solid black',
                          //   margin: 0,
                          //   padding: 0,
                          // }}
                          >
                            {type === 'Table' && (
                              <a
                                href="/"
                                className="btn btn-link"
                                onClick={(e) =>
                                  handleBrowseClick(e, item.name, type)
                                }
                              >
                                <small> Browse</small>
                              </a>
                            )}
                            <a
                              href="/"
                              className="btn btn-link"
                              onClick={(e) =>
                                handleStructureClick(e, item.name, type)
                              }
                            >
                              <small> Structure</small>
                            </a>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* <ul className="scrollable-list" style={listStyle}>
            {filteredObjects &&
              filteredObjects.length > 0 &&
              Object.entries(groupBy(filteredObjects, 'type')).map(
                ([type, names]) => (
                  <li key={type}>
                    <strong>{type}</strong>
                    <ul>
                      {names.map((name, index) => (
                        <li key={name}>
                          <strong>{name}</strong>
                          <div
                            style={{
                              border: '1px solid black',
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            <a
                              href="/"
                              className="btn btn-link"
                              onClick={(e) => handleBrowseClick(e, name, type)}
                            >
                              <small> Browse</small>
                            </a>
                            <a
                              href="/"
                              className="btn btn-link"
                              onClick={(e) =>
                                handleStructureClick(e, name, type)
                              }
                            >
                              <small> Structure</small>
                            </a>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </li>
                )
              )}
          </ul> */}
        </div>
        <div className="col-10" style={{ background: '#f0f0f0' }}>
          <h2 className="mb-4">SQL Query Executor</h2>
          <div style={{ width: '95%', height: '400px', margin: '10px' }}>
            <AceEditor
              mode="sql"
              theme="github"
              onChange={handleChange}
              name="sql-editor"
              value={query}
              editorProps={{ $blockScrolling: true }}
              setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true,
                wrap: true, // Enables word wrap
                useWorker: false, // Prevents syntax checking warnings
              }}
              width="100%"
              height="100%"
            />
          </div>
          {/* <SqlEditor /> */}
          {/* <div className="mb-3">
            <label htmlFor="query" className="form-label">
              Enter SQL Query:
            </label>
            <textarea
              id="query"
              className="form-control"
              rows="5"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Write your SQL query here..."
            ></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="preview" className="form-label">
              Query Preview (Syntax Highlighted):
            </label>
            <pre
              id="preview"
              className="p-3 bg-light rounded border"
              style={{ whiteSpace: 'pre-wrap', overflowX: 'auto' }}
              dangerouslySetInnerHTML={{
                __html: hljs.highlight(query, { language: 'sql' }).value,
              }}
            ></pre>
          </div> */}
          <div className="d-flex">
            {' '}
            <button
              className="btn btn-primary btn-sm ml-auto"
              onClick={executeQuery}
              disabled={loading}
            >
              {loading ? `Loading... ${counter} sec` : 'Execute Query'}
            </button>
          </div>

          {result && Array.isArray(result) && result.length > 0 && (
            <div className="mt-4">
              <h2>Query Results</h2>
              {isNestedArray ? (
                result.map((result, index) => {
                  if (Array.isArray(result)) {
                    return (
                      <div key={index} className="mb-4">
                        <h4>
                          Result Set {index + 1} (Array) - {result.length} rows
                        </h4>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                {Object.keys(result[0] || {}).map((key) => (
                                  <th key={key}>{key}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {result.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {Object.values(row).map((value, colIndex) => (
                                    <td key={colIndex}>
                                      <pre className="text-wrap">
                                        {value !== null ? value : 'NULL'}
                                      </pre>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  } else {
                    // For non-array results
                    return (
                      <div key={index} className="mb-4">
                        <h4>Result Set {index + 1}</h4>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                {Object.keys(result).map((key) => (
                                  <th key={key}>{key}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {Object.values(result).map(
                                  (value, colIndex) => (
                                    <td key={colIndex}>
                                      {value !== null ? value : 'NULL'}
                                      <pre className="text-wrap">
                                        {value !== null ? value : 'NULL'}
                                      </pre>
                                    </td>
                                  )
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  }
                })
              ) : (
                <div className="mb-4">
                  <h4>Single Result - {result.length} rows</h4>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          {Object.keys(result[0] || {}).map((key) => (
                            <th key={key}>{key}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {result.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.values(row).map((value, colIndex) => (
                              <td key={colIndex}>
                                <pre className="text-wrap">
                                  {value !== null ? value : 'NULL'}
                                </pre>
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}

          {rowsAffected !== null && (
            <div className="mt-4">
              <h4>Query Executed Successfully</h4>
              <p>{rowsAffected} row(s) affected.</p>
            </div>
          )}

          {result &&
            (!Array.isArray(result) || result.length === 0) &&
            rowsAffected === null && (
              <div className="mt-4">
                <h4>No data returned from the query.</h4>
              </div>
            )}

          {error && (
            <div className="mt-4 text-danger">
              <strong>Error:</strong> {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SQLQueryPage;
